import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom"; 
import { serverHost } from "variables/serverdata";
import { useKeycloak } from 'variables/keycloak';
import { ThemeContext } from "contexts/ThemeContext"; 
function Login() {

    const { themePreference } = useContext(ThemeContext);
    const navigate = useNavigate();
    const [auth, setAuth] = useState(false);
    const keycloak = useKeycloak();
    //Authenticate with Keycloak interface
      useEffect(() => {
        // Keycloak is already initialized from index.js
        if (keycloak.authenticated) {
          // User is authenticated, handle your post-login logic
          setAuth(keycloak.authenticated);
        } else {
          // Not authenticated, redirect to Keycloak login
          keycloak.login();
        }
    }, [keycloak.authenticated]);
    useEffect(() => {
      if (!auth) return; // stop the effect if not authenticated
      //Successful authentication - query for access token
      let url = `${serverHost}/access_token`;
      
      let headers = {
        Authorization: `Bearer ${keycloak.token}`,
      }
      //check if the user was invited - needed for client id
      if(localStorage.getItem("inviteToken")) headers.Invite = localStorage.getItem("inviteToken");  
      
      // if(keycloak.tokenParsed.isNew) url = `${serverHost}/register` //New user has been created, add to new database, then generate token
      async function fetchData() {
      try {
        console.log(`Fetching from URL with token ${keycloak.token}`);
        const resp = await fetch(url, {
          headers: headers
        });

        console.log('API Response:', {
          status: resp.status,
          statusText: resp.statusText,
          headers: Object.fromEntries(resp.headers)
        });
        localStorage.removeItem("inviteToken");
        
        if (!resp.ok) {
          throw new Error(`API request failed: ${resp.status} ${resp.statusText}`)
        }

        const responseText = await resp.text();
        console.log('Raw API Response:', responseText);

        const userData = JSON.parse(responseText).userData;
        console.log('Initial user data from API:', userData);

        if (!userData) {
          console.error('No user data returned from API');
          return;
        } 
        const basicUserData = {
          user_uuid: userData.user_uuid,
          email: userData.email_address,
          firstName: userData.first_name,
          lastName: userData.last_name,
          role: userData.user_role,
          dealer_uuid: userData.dealer_uuid,
          client_uuid: userData.client_uuid,
          site_uuid: userData.site_uuid,
          theme: userData.theme,
          module_perms: userData.module_perms
        };
        themePreference(userData.theme)

        localStorage.setItem('user', JSON.stringify(basicUserData));
        console.log(userData)
        // await the async function
        // Replace the fetchCompleteUserData call
      let completeUserData = null;
      try {
        const resp = await fetch(`${serverHost}/get_user_role/${userData.user_uuid}`);
        if (resp.ok) {
          const data = await resp.json();
          completeUserData = { ...userData, role: data.user_role }; // merge with basic data
          localStorage.setItem('user', JSON.stringify(completeUserData));
        } else {
          console.warn('Could not fetch complete user data, using basic data');
        }
      } catch (err) {
        console.error('Error fetching complete user data:', err);
      }


        if (completeUserData) {  
          completeUserData = {
            ...completeUserData,
            access: userData.access
          }
          console.log('Complete user data fetched:', completeUserData);
          localStorage.setItem('user', JSON.stringify(completeUserData));
        } else {
          console.warn('Could not fetch complete user data, using basic data');
        }
        
        if (completeUserData?.site) {
          window.dispatchEvent(new CustomEvent('siteChanged', { detail: completeUserData.site.site_uuid }));
        }

        // after fetching completeUserData
        console.log("Log in attempt with role: ", completeUserData.user_role)
        const role = completeUserData.user_role;

        if (role === "USER" || role === "ADMIN" || role === "SUPERADMIN") {
          // Fetch the site info for this user
          try {
           const token = JSON.parse(localStorage.getItem("user")).access_token;

            const siteResp = await fetch(`${serverHost}/fetch_user_site`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (siteResp.ok) {
              const siteData = await siteResp.json();
              if (siteData.data) {
                localStorage.setItem("selectedSite", JSON.stringify(siteData.data));
                window.dispatchEvent(new CustomEvent('siteChanged', { detail: siteData.data.site_uuid }));
                console.log("User's site set:", siteData.data);
              }
            } else {
              console.warn("Failed to fetch user's site");
            }
          } catch (err) {
            console.error("Error fetching user's site:", err);
          }
        }

        
        if (role === "GLOBAL" || role === "SALES" || role === "TECH") {
          navigate("/dealer/dashboard");
        } else {
          navigate("/admin/home");
        }

      } catch (err) {
        console.error("Fetch failed:", err);
      }
    }

    fetchData();
  }, [auth, keycloak, navigate]);
}

export default Login;